"use client";
import React from "react";
import Image from "next/image";
import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IMAGES, CREDIT_SCORE_FEATURES } from "@/lib/constants";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import styles from "../creditscore.module.css";
const CreditScoreLeftCard = () => {
  const t = useTranslations("creditScore");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  const path = usePathname();
  return (
    <Stack>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Typography variant="h6" fontWeight={"bold"} color={"#FFFFFF"}>
            {t("checkcreditscore")}
          </Typography>

          <Typography
            variant="h6"
            align="left"
            fontWeight={300}
            fontSize={{ xs: 12, sm: 16 }}
            color={"#FFFFFF"}
          >
            {t("getcreditscore")}
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={{ xs: 0.5 }}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} sx={{ pt: 3 }}>
            <Stack gap={{ xs: 0.5, sm: 2 }}>
              {CREDIT_SCORE_FEATURES.map((item, index) => (
                <Stack
                  key={index}
                  className={styles["gradient-border-box"]}
                  direction={"row"}
                  spacing={1}
                  p={1}
                  borderRadius={1}
                  alignItems={"center"}
                >
                  <Image
                    src={item.icon}
                    alt="Banner"
                    height={isBelowMd ? 20 : 32}
                    width={isBelowMd ? 20 : 32}
                  />
                  <Typography fontSize={{ xs: 10, sm: 14 }} color={"#fff"}>
                    {t(item.textKey)}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>
        {path?.includes("personal") && (
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              sx={{
                position: "relative",
                height: "fit-content",
                height: isBelowMd ? 111 : 200,
              }}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"flex-end"}
                position={"absolute"}
                right={isBelowMd ? -50 : -74}
              >
                <Image
                  src={IMAGES.loanhand}
                  alt="Banner"
                  height={isBelowMd ? 111 : 200}
                  width={isBelowMd ? 150 : 320}
                />
              </Stack>
            </Grid>
          </Grid>
        )}
      </Stack>
    </Stack>
  );
};

export default CreditScoreLeftCard;
